module.exports = __webpack_public_path__ + "img/consultoria_16-9_640.60e0cd4f.webp";